// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { socialLinksStyles } from "@vanmeter/Overrides/Widgets/Basic/SocialLinks";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";
import { color } from "@vanmeter/XDL/Utilities";

socialLinksStyles.mainContainer = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

socialLinksStyles.mainTitle = { variant: "h5", color: "common.white" };

socialLinksStyles.socialLinkListWrapper = {
    css: css`
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        gap: 16px;
        .link-wrapper {
            display: flex;
        }
    `,
};

socialLinksStyles.link = {
    css: css`
        ${IconWrapper} {
            width: auto;
            margin: 0;
            & > svg {
                width: revert-layer;
            }
        }
        &:hover {
            ${IconWrapper} {
                color: ${color("common.ui17")};
            }
        }
    `,
};
